import { AfterViewInit, Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { createInspection, deleteInspection, getAllInspection } from 'src/app/store/actions/inspection.action';
import { InspectionState } from 'src/app/store/reducers/inspection.reducer';
import { selectAllInspections } from 'src/app/store/selector/inspection.selector';

interface Inspection {
  code: string;
  nom: string;
  type: string;
  logo: any | null;
}

import {
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexPlotOptions,
  ApexDataLabels,
  ApexTooltip
} from "ng-apexcharts";
import { selectAllUtilisateur } from 'src/app/store/selector/utilisateur.selector';
import { DataService } from 'src/app/services/data.service';
import { selectAllCertificatControls, selectCertificatsControlsAmount } from 'src/app/store/selector/certificatControl.selector';
import { createInspectionMontant, deleteInspectionMontant, getCertificatControlsAmount } from 'src/app/store/actions/certificatControl.action';
import { getAllChartObject } from 'src/app/store/actions/chartObject.action';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  plotOptions: ApexPlotOptions;
  dataLabels: ApexDataLabels;
  colors: string[];
  tooltip: ApexTooltip;
};


@Component({
  selector: 'app-technical-parteners',
  templateUrl: './technical-parteners.component.html',
  styleUrls: ['./technical-parteners.component.css']
})
export class TechnicalPartenersComponent implements OnInit {
  inpections$: Observable<ReadonlyArray<any>>;
  inspectionStatusChart: any;
  isDarkMode = false;
  authLogs: any[] = [];
  filteredAuthLogs: any[] = [];
  paginatedAuthLogs: any[] = [];
  selectedAuthLog: any | null = null;

  // Filtres
  authLogSearch: string = '';
  authLogStartDate: string = '';
  authLogEndDate: string = '';
  authLogSortField: string = 'date';
  authLogSortDirection: 'asc' | 'desc' = 'desc';

  // Pagination
  authLogCurrentPage: number = 1;
  authLogsPerPage: number = 10;
  authLogTotalPages: number = 0;
  authLogStartIndex: number = 0;
  authLogEndIndex: number = 0;
  authLogVisiblePages: number[] = [];
  utilisateurs$: Observable<ReadonlyArray<any>>;
  certificatControls$: Observable<any>;
  constructor(private store: Store<any>, private dataService: DataService) {
    this.inpections$ = this.store.pipe(select(selectAllInspections))
    this.utilisateurs$ = this.store.pipe(select(selectAllUtilisateur))
    this.certificatControls$ = this.store.pipe(select(selectAllCertificatControls))
  }
  isStatsCardCollapsed = false;

  toggleStatsCard() {
    this.isStatsCardCollapsed = !this.isStatsCardCollapsed;
  }
  // Exemple TypeScript (dans ton composant)
  usersByPartyChart: ChartOptions = {
    series: [{
      name: 'Cartes Créés',
      data: [25, 40, 15, 20] // Tes vraies données ici
    }],
    chart: {
      type: "bar",  // Ici, c'est typé strictement, donc "bar" entre guillemets
      height: 350
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: false
      }
    },
    dataLabels: {
      enabled: true
    },
    xaxis: {
      categories: ['Parti A', 'Parti B', 'Parti C', 'Parti D']
    },
    colors: ['#1E3A8A', '#9333EA', '#10B981', '#F59E0B'],
    tooltip: {
      y: {
        formatter: function (val: number) {
          return `${val} Cartes Créés`;
        }
      }
    }
  };


  utilisateurs: any[] = []
  inspections: any = []
  cardCreated: number = 0
  rapportCreated: number = 0
  montant: number = 0
  amountCard: number = 0
  rapportAmount: any = []
  pieChartData: any[] = []
  ngOnInit(): void {
    this.store.dispatch(getCertificatControlsAmount())
    this.store.dispatch(getAllChartObject())
    this.store.dispatch(getAllInspection())

    this.initializeChart();
    this.inpections$.subscribe((inspections: any) => {
      console.log(inspections.inspections)
      if (Array.isArray(inspections.inspections) && inspections.inspections.length > 0) {
        this.inspections = inspections.inspections
      } else {
        console.log('No inspections found or still loading.');
      }
    });

    this.certificatControls$.subscribe((certificatControls: any) => {
      this.amountCard = certificatControls.totalAmount
      this.rapportAmount = certificatControls.montant

    })
    this.utilisateurs$.subscribe((utilisateurs: any) => {
      console.log(utilisateurs)
      if (Array.isArray(utilisateurs.utilisateurs) && utilisateurs.utilisateurs.length > 0) {
        this.utilisateurs = utilisateurs.utilisateurs
      } else {
        console.log('No utilisateurs found or still loading.');
      }
    });

    this.dataService.CountBadgeCreated().subscribe(res => {
      this.cardCreated = res

    })

    this.dataService.countRapportCreated().subscribe(res => {
      this.rapportCreated = res
    })
    this.dataService.pieChartData().subscribe(res => {
      this.pieChartData = [...res]
      this.inspectionStatusChart = {
        ...this.inspectionStatusChart,
        series: [...res]
      }
    })

    this.dataService.countBadgePerInspecton().subscribe(res => {
      this.usersByPartyChart = {
        ...this.usersByPartyChart,
        series: [{
          name: "Cartes d'inspection créés",
          data: res.yaxis
        }],
        xaxis: {
          categories: res.xaxis
        },
      }
    })

    this.dataService.certificatControlsStatsByInspection().subscribe(res => {
      this.inspectionTrendChart = {
        ...this.inspectionTrendChart,
        series: [...res]
      }
    })
  }

  // Modals
  showAuthLogDetailsModal: boolean = false;

  // Méthodes pour les logs d'authentification
  loadAuthLogs() {
    // this.authLogService.getAuthLogs().subscribe(logs => {
    //   this.authLogs = logs;
    //   this.applyAuthLogFilters();
    // });
  }

  applyAuthLogFilters() {
    let filtered = this.authLogs;

    // Filtre par recherche
    if (this.authLogSearch) {
      const searchTerm = this.authLogSearch.toLowerCase();
      filtered = filtered.filter(log =>
        log.utilisateur?.nom?.toLowerCase().includes(searchTerm) ||
        log.utilisateur?.prenom?.toLowerCase().includes(searchTerm) ||
        log.utilisateur?.userName?.toLowerCase().includes(searchTerm) ||
        log.localisation?.toLowerCase().includes(searchTerm)
      );
    }

    // Filtre par date
    if (this.authLogStartDate) {
      const startDate = new Date(this.authLogStartDate);
      filtered = filtered.filter(log => new Date(log.date) >= startDate);
    }

    if (this.authLogEndDate) {
      const endDate = new Date(this.authLogEndDate);
      endDate.setHours(23, 59, 59, 999);
      filtered = filtered.filter(log => new Date(log.date) <= endDate);
    }

    // Tri
    filtered.sort((a, b) => {
      let aValue: any = a;
      let bValue: any = b;

      // Navigation dans les propriétés imbriquées
      const fields = this.authLogSortField.split('.');
      fields.forEach(field => {
        aValue = aValue?.[field];
        bValue = bValue?.[field];
      });

      if (this.authLogSortDirection === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });

    this.filteredAuthLogs = filtered;
    this.updateAuthLogsPagination();
  }

  resetAuthLogFilters() {
    this.authLogSearch = '';
    this.authLogStartDate = '';
    this.authLogEndDate = '';
    this.applyAuthLogFilters();
  }

  sortAuthLogs(field: string) {
    if (this.authLogSortField === field) {
      this.authLogSortDirection = this.authLogSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.authLogSortField = field;
      this.authLogSortDirection = 'desc';
    }
    this.applyAuthLogFilters();
  }

  // Méthodes utilitaires pour la localisation
  getLocationDetails(localisation: string): any {
    if (!localisation) return null;

    // Implémentez la logique pour parser la localisation
    // Exemple: "Paris, France" -> { city: "Paris", country: "France" }
    try {
      const parts = localisation.split(', ');
      return {
        city: parts[0],
        country: parts[1] || ''
      };
    } catch {
      return null;
    }
  }

  getIPFromLocation(localisation: string): string {
    // Implémentez la logique pour extraire l'IP de la localisation
    // ou utilisez un service séparé pour les informations IP
    return '192.168.1.1'; // Exemple
  }

  getDeviceInfo(log: any): string {
    // Implémentez la logique pour détecter le device
    // Basé sur user-agent ou autres métadonnées
    return 'Chrome, Windows'; // Exemple
  }

  // Pagination pour les logs d'authentification
  updateAuthLogsPagination() {
    this.authLogTotalPages = Math.ceil(this.filteredAuthLogs.length / this.authLogsPerPage);
    this.authLogStartIndex = (this.authLogCurrentPage - 1) * this.authLogsPerPage;
    this.authLogEndIndex = Math.min(this.authLogStartIndex + this.authLogsPerPage, this.filteredAuthLogs.length);
    this.paginatedAuthLogs = this.filteredAuthLogs.slice(this.authLogStartIndex, this.authLogEndIndex);

    this.updateAuthLogsVisiblePages();
  }

  updateAuthLogsVisiblePages() {
    const pages = [];
    const startPage = Math.max(1, this.authLogCurrentPage - 2);
    const endPage = Math.min(this.authLogTotalPages, startPage + 4);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    this.authLogVisiblePages = pages;
  }

  goToAuthLogPage(page: number) {
    this.authLogCurrentPage = page;
    this.updateAuthLogsPagination();
  }

  previousAuthLogPage() {
    if (this.authLogCurrentPage > 1) {
      this.authLogCurrentPage--;
      this.updateAuthLogsPagination();
    }
  }

  nextAuthLogPage() {
    if (this.authLogCurrentPage < this.authLogTotalPages) {
      this.authLogCurrentPage++;
      this.updateAuthLogsPagination();
    }
  }

  // Modal methods
  viewAuthLogDetails(log: any) {
    this.selectedAuthLog = log;
    this.showAuthLogDetailsModal = true;
  }

  closeAuthLogDetailsModal() {
    this.showAuthLogDetailsModal = false;
    this.selectedAuthLog = null;
  }

  // Export
  exportAuthLogs() {
    // Implémentez l'export CSV ou Excel
    console.log('Export des logs d\'authentification');
  }
  initializeChart(): void {
    this.inspectionStatusChart = {
      series: [65, 35], // 65% Active, 35% Désactivée
      chart: {
        type: 'pie',
        height: 300,
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
          animateGradually: {
            enabled: true,
            delay: 150
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350
          }
        },
        foreColor: this.isDarkMode ? '#FFFFFF' : '#000000'
      },
      labels: ['Activé', 'Désactivé'],
      colors: ['#10B981', '#EF4444'], // Vert pour Active, Rouge pour Désactivée
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }],
      dataLabels: {
        enabled: true,
      },
      tooltip: {
        theme: this.isDarkMode ? 'dark' : 'light'
      }
    };
  }


  // Ajoutez cette configuration pour le nouveau line chart
  inspectionTrendChart: any = {
    series: [
      {
        name: "Inspections Planifiées",
        data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
      },
      {
        name: "Inspections Réalisées",
        data: [25, 32, 28, 45, 42, 55, 60, 85, 110]
      }
    ],
    chart: {
      type: 'line',
      height: 350,
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800
      },
      foreColor: this.isDarkMode ? '#FFFFFF' : '#000000',
      toolbar: {
        show: false
      }
    },
    colors: ['#3B82F6', '#10B981'], // Bleu pour planifiées, Vert pour réalisées
    stroke: {
      width: 3,
      curve: 'smooth'
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
      labels: {
        style: {
          colors: this.isDarkMode ? '#FFFFFF' : '#000000'
        }
      }
    },
    yaxis: {
      labels: {
        style: {
          colors: this.isDarkMode ? '#FFFFFF' : '#000000'
        }
      }
    },
    grid: {
      borderColor: this.isDarkMode ? '#374151' : '#E5E7EB'
    },
    tooltip: {
      theme: this.isDarkMode ? 'dark' : 'light',
      shared: true,
      intersect: false
    },
    legend: {
      position: 'top',
      labels: {
        colors: this.isDarkMode ? '#FFFFFF' : '#000000'
      }
    }
  };

  // N'oubliez pas de mettre à jour les couleurs dans la méthode updateChartColors()

  // Dans votre composant.ts
  showDetailsModal = false;
  showInspectionMontantDetailsModal = false
  showConfirmationModal = false;
  selectedPartner: any = null;

  // Méthode pour ouvrir le modal de détails
  openDetailsModal(partner: any) {
    this.selectedPartner = partner;
    this.showDetailsModal = true;
  }

  inspectionMontant: any = {}
  openInspectionAmountDetailsModal(inspectionMontant: any) {
    this.inspectionMontant = inspectionMontant
    this.showInspectionMontantDetailsModal = true
  }

  // Méthode pour ouvrir le modal de confirmation
  openConfirmationModal(param: string) {
    this.showDetailsModal = false;
    this.origin = param
    this.showConfirmationModal = true;
  }

  showConfirmationInspectionMontantModal = false
  openConfirmationModalForInspectionMontant(id: number) {
    this.showInspectionMontantDetailsModal = false
    this.showConfirmationInspectionMontantModal = true;
  }
  deleteInspectionMontant(id: number) {
    this.store.dispatch(deleteInspectionMontant(id))

  }
  deleteInspection() {
    this.store.dispatch(deleteInspection(this.selectedPartner.id))
  }
  handleClick() {
    if (this.origin === 'Suppression') {
      this.deleteInspection();
      this.showConfirmationModal = false
    } else {
      this.togglePartnerStatus();
      this.showConfirmationModal = false
    }
  }


  // Méthode pour basculer le statut
  togglePartnerStatus() {
    if (this.selectedPartner) {
      // Ici vous devriez appeler votre service pour mettre à jour le statut
      const updatedPartner = { ...this.selectedPartner };
      this.store.dispatch(createInspection(updatedPartner))
    }

    this.showConfirmationModal = false;
    this.selectedPartner = null;
  }
  openEditModal(inspectionData: any) {
    this.newInspection = { ...inspectionData };
    this.showNewInspectionModal = true;
  }
  showNewInspectionModal = false;
  showInspectionAmountModal = false;
  selectedFile: File | null = null;
  filePreview: string | ArrayBuffer | null = null;

  newInspection: Inspection = {
    code: '',
    nom: '',
    type: 'TRACTEUR',
    logo: null
  };

  inspectionTypes = [
    { value: 'TRACTEUR', label: 'Tracteur' },
    { value: 'REMORQUE', label: 'Remorque' },
    { value: 'ENGIN', label: 'Engin' }
  ];

  openNewInspectionModal(): void {
    this.showNewInspectionModal = true;
  }

  openInspectionAmountModal() {
    this.showInspectionAmountModal = true
  }

  closeNewInspectionModal(): void {
    this.showNewInspectionModal = false;
    this.resetForm();
  }

  closeInspectionAmountModal() {
    this.showInspectionAmountModal = false;
    this.resetForm();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.selectedFile = input.files[0];

      const reader = new FileReader();
      reader.onload = (e) => {
        this.filePreview = e.target?.result as string;
        this.newInspection.logo = this.filePreview; // Stocke le base64
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }

  isFormValid(): boolean {
    return !!this.newInspection.code &&
      !!this.newInspection.nom &&
      !!this.newInspection.type;
  }

  origin: string = ""

  submitInspectionMontant() {
    this.store.dispatch(createInspectionMontant({ montant: this.montant }))
  }
  submitInspection(): void {
    if (!this.isFormValid()) return;
    console.log(this.newInspection)
    this.store.dispatch(createInspection(this.newInspection))
    this.resetForm();
    this.closeNewInspectionModal();
  }

  private resetForm(): void {
    this.newInspection = {
      code: '',
      nom: '',
      type: 'TRACTEUR',
      logo: null
    };
    this.selectedFile = null;
    this.filePreview = null;
  }
}
